<template>
  <!-- SPEC-CHINA-ECOUNT-TX-LINK-001 파트 B: 연결키 설명 모달 -->
  <a-modal
    :open="visible"
    :title="$t('ecountTxLink_modal_title')"
    :footer="null"
    :width="640"
    @cancel="$emit('close')"
  >
    <!-- 규칙 1: 이카운트 → Lot 내부 연결 -->
    <a-card
      size="small"
      :title="$t('ecountTxLink_rule1_label')"
      style="margin-bottom: 16px;"
    >
      <p style="margin-bottom: 12px; color: #595959; font-size: 13px;">
        {{ $t('ecountTxLink_rule1_desc') }}
      </p>

      <!-- matchKey 흐름 다이어그램 -->
      <div class="txlink-flow">
        <div class="txlink-flow-step txlink-step-salesline">
          <div class="txlink-step-label">{{ $t('ecountTxLink_step_salesLine') }}</div>
          <div class="txlink-step-fields">
            <code>transactionDate</code>
            <code>voucherNo</code>
            <code>lineNo</code>
          </div>
        </div>
        <div class="txlink-flow-arrow">→</div>
        <div class="txlink-flow-step txlink-step-matchkey">
          <div class="txlink-step-label">{{ $t('ecountTxLink_step_matchKey') }}</div>
          <div class="txlink-step-fields">
            <code class="txlink-key-format">{{ $t('ecountTxLink_matchKey_format') }}</code>
          </div>
        </div>
        <div class="txlink-flow-arrow">→</div>
        <div class="txlink-flow-step txlink-step-serial">
          <div class="txlink-step-label">{{ $t('ecountTxLink_step_serialLot') }}</div>
          <div class="txlink-step-fields">
            <code>serialLotMatchKey</code>
          </div>
        </div>
      </div>

      <!-- matchKey 형식 표 -->
      <table class="txlink-table">
        <thead>
          <tr>
            <th>{{ $t('ecountTxLink_matchKey_label') }}</th>
            <th>{{ $t('ecountTxLink_matchKey_format') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>tenantKey</code></td>
            <td>{{ $t('ecountEtl_salesLines_col_dataSid') }} 기준 테넌트 식별자</td>
          </tr>
          <tr>
            <td><code>YYYYMMDD</code></td>
            <td>{{ $t('ecountEtl_salesLines_col_transactionDate') }} (UTC)</td>
          </tr>
          <tr>
            <td><code>voucherNo</code></td>
            <td>{{ $t('ecountEtl_salesLines_col_voucherNo') }}</td>
          </tr>
          <tr>
            <td><code>lineNo</code></td>
            <td>{{ $t('ecountEtl_salesLines_col_lineNo') }}</td>
          </tr>
        </tbody>
      </table>
    </a-card>

    <!-- 규칙 2: Lot ↔ 딜러 배치 연결 -->
    <a-card
      size="small"
      :title="$t('ecountTxLink_rule2_label')"
      style="margin-bottom: 16px;"
    >
      <p style="margin-bottom: 12px; color: #595959; font-size: 13px;">
        {{ $t('ecountTxLink_rule2_desc') }}
      </p>

      <!-- Lot → 딜러 연결 흐름 -->
      <div class="txlink-flow">
        <div class="txlink-flow-step txlink-step-serial">
          <div class="txlink-step-label">{{ $t('ecountTxLink_step_serialLot') }}</div>
          <div class="txlink-step-fields">
            <code>lotNumber</code>
          </div>
        </div>
        <div class="txlink-flow-arrow">↔</div>
        <div class="txlink-flow-step txlink-step-dealer">
          <div class="txlink-step-label">{{ $t('ecountTxLink_step_dealer') }}</div>
          <div class="txlink-step-fields">
            <code>batchNumber</code>
            <code>batchCode</code>
          </div>
        </div>
      </div>

      <div class="txlink-note">
        <strong>{{ $t('ecountTxLink_lotDealerLink_label') }}:</strong>
        serial_lot_transactions.<code>lotNumber</code>
        = dealer_gsp_batch.<code>batchNumber</code> or <code>batchCode</code>
      </div>
    </a-card>

    <div style="text-align: right; margin-top: 8px;">
      <a-button @click="$emit('close')">{{ $t('ecountTxLink_close') }}</a-button>
    </div>
  </a-modal>
</template>

<script>
// SPEC-CHINA-ECOUNT-TX-LINK-001 파트 B
// BatchKeyInfoModal.vue 패턴 답습
export default {
  name: 'EcountTxLinkInfoModal',
  props: {
    // [HARD] class/style props 정의 금지 — Vue 3 fallthrough attribute 차단됨
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
};
</script>

<style scoped>
.txlink-flow {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.txlink-flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 120px;
}

.txlink-step-label {
  font-size: 11px;
  font-weight: 600;
  color: #595959;
  white-space: nowrap;
}

.txlink-step-fields {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
}

.txlink-step-salesline .txlink-step-label { color: #1890ff; }
.txlink-step-matchkey .txlink-step-label { color: #722ed1; }
.txlink-step-serial .txlink-step-label { color: #13c2c2; }
.txlink-step-dealer .txlink-step-label { color: #52c41a; }

.txlink-key-format {
  font-size: 11px;
  background: #f9f0ff;
  border: 1px solid #d3adf7;
  color: #722ed1;
  padding: 2px 6px;
  border-radius: 3px;
}

.txlink-flow-arrow {
  font-size: 18px;
  color: #8c8c8c;
  padding-top: 20px;
  font-weight: bold;
}

.txlink-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-top: 8px;
}

.txlink-table th,
.txlink-table td {
  border: 1px solid #f0f0f0;
  padding: 6px 10px;
  text-align: left;
}

.txlink-table th {
  background: #fafafa;
  font-weight: 600;
}

.txlink-note {
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  color: #135200;
  line-height: 1.6;
}

code {
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 11px;
  font-family: 'Courier New', Courier, monospace;
}
</style>
